import { IPlayerSeasonStats } from "../../types/types";
import type { StatTier } from "../playerStatTiers";

const tierFromRatio = (ratio: number): StatTier => {
  if (ratio >= 0.8) return "excellent";
  if (ratio >= 0.6) return "good";
  if (ratio >= 0.4) return "average";
  if (ratio >= 0.2) return "low";
  return "poor";
};

const normalizeCount = (value: number | undefined): number =>
  value == null || Number.isNaN(value) ? 0 : value;

export const buildRelativeCountTierFn = (
  rows: IPlayerSeasonStats[],
  pick: (row: IPlayerSeasonStats) => number | undefined,
): ((value: number | undefined) => StatTier) => {
  const counts = rows.map((row) => normalizeCount(pick(row)));
  const max = counts.length > 0 ? Math.max(...counts) : 0;

  if (max === 0) {
    return () => "neutral";
  }

  const distinct = [...new Set(counts)].sort((a, b) => a - b);

  if (distinct.length === 1) {
    return (value) => (normalizeCount(value) > 0 ? "excellent" : "poor");
  }

  const rankRatio = (count: number): number => {
    const index = distinct.indexOf(count);
    if (index < 0) return 0;
    return index / (distinct.length - 1);
  };

  return (value) => tierFromRatio(rankRatio(normalizeCount(value)));
};
